 <!-- 合同详情 -->
<template>
  <div>
    <el-dialog :title="contractMsg.contractName" ref="contractDialog" :visible.sync="contractDialogVisible" width="70%">
      <div class="contract_box infinite-list" style="overflow:auto">
        <div class="contractName">运输服务框架合同</div>
        <div class="t_r mr_t10">合同编号： <span class="date">{{contractMsg.contractNo}}</span></div>
        <div>甲方（托运人）：<span class="date">{{contractMsg.customerName}}</span></div>
        <div>地址：<span class="date">{{contractMsg.address}}</span></div>
        <div>法定代表人： <span class="date">{{contractMsg.corporaName}}</span></div>
        <div class="mr_t20">乙方（承运人）： <span class="date">{{contractMsg.partyName}}</span></div>
        <div>地址：<span class="date">{{contractMsg.partyNameAddress}}</span></div>
        <div> 法定代表人： <span class="date">{{contractMsg.partyNameLegal}}</span></div>
        <div class="ti mr_t20">
          甲乙双方在平等互利、诚信合作的基础上，约定乙方为甲方提供公路运输服务。本协议为甲乙双方合作的框架协议，甲方可依据本合同委托乙方及乙方关联公司（附件一）提供运输服务。本协议约定乙方的权利、义务和法律关系地位同样适用于作为承运方的乙方的各关联公司。</div>
        <div class="ti">乙方是国内公路物流信息化的领先企业，通过其运营的“顺陆”APP/软件/网站等（含货主版及司机版，统称“顺丰运力”或“乙方平台”）为用户提供物流信息服务与相关增值服务，同时乙方亦作为网络货运经营者为企业用户/货主用户提供运输服务。</div>
        <div class="ti">现甲乙双方就乙方为甲方提供运输服务的相关事宜约定如下：</div>

        <h4 class="mr_20">1、概述</h4>
        <h4 class="mr_10">1.1 双方陈述及保证</h4>
        <div class="mr_t10">1.1.1甲方与乙方均系经中国政府批准依法成立的企业法人，具有签订及履行本合同的法律资格、民事权利能力和民事行为能力。</div>
        <div class="mr_t10">1.1.2在签订本合同时，甲方与乙方均已完成签订本合同所必需的内部认可手续。甲乙双方签署本合同，即表明双方已知悉本合同及相关附件的所有约定，并认可其法律效力，承诺遵照执行。</div>
        <h4 class="mr_10">1.2 合作方式</h4>
        <div class="mr_t10">1.2.2 甲方同意，作为乙方的合作伙伴，注册成为“顺丰运力”的会员，使用“顺丰运力”发布货运信息、寻找合适的运力，同时亦会委托乙方以网络货运模式，另行委托实际承运人为甲方提供运输服务。</div>
        <div class="mr_t10"> 1.2.3 甲方在顺丰运力平台上成功注册后，将获得相应使用账号。甲方应妥善保管注册的账户及密码，如系统显示甲方账户下单，无论在任何情况下均视为甲方行为，甲方不得以包括但不限于非甲方自行下单、账户、密码丢失而导致原因抗辩，甲方需对其账户的下单行为承担全部责任。</div>
        <h4 class="mr_10">1.3 运输订单</h4>
        <div class="mr_t10">1.3.1 甲方在本框架合同有效期内将依据自身业务需求，不定时委托乙方运输货物，运输方式为汽车公路整车运输。</div>
        <div class="mr_t10"> 1.3.2 甲方在乙方平台完成下单操作，即视为甲方向乙方发出货物运输需求，下单所形成的订单所有信息内容作为本合同的附件，与本合同具有同等法律效力。</div>
        <div class="mr_t10"> 1.3.3 甲方应在乙方平台下单界面向乙方如实告知，下单成功后，非经乙方同意时不得擅自更改，否则应承担因此造成的费用及损失。</div>

        <h4 class="mr_20">2、双方的权利与义务</h4>
        <h4 class="mr_10">2.1 甲方权利</h4>
        <div class="mr_t10">2.1.1 甲方有权要求乙方妥善完成运输服务，甲方应当向乙方准确表明收货人的名称或者姓名、货物的名称、性质、重量、数量、装卸货地点详细地址等有关货物运输的必要情况。甲方因其申报不实或者遗漏重要情况产生损失的，由甲方自行承担，若因此造成乙方损失的，甲方应当承担赔偿责任。货物运输需要办理审批、检验等手续的，甲方应当将办理完有关手续的文件提交给乙方。</div>
        <div class="mr_t10">2.1.2 在货物送达收货人之前，甲方有权随时要求中止运输、改变货物到达地点和收货人、返还货物等，但应支付因此所增加的运费及其它费用，具体收费标准以乙方平台规则为准（包括但不限于订单页面《异常费用收取与补偿标准》等）。</div>
        <div class="mr_t10">2.1.3 甲方下单后，有权取消运单。若乙方已经安排车辆，但车辆未出发则无需支付空驶费。若车辆已出发（以乙方系统定位数据为准），则甲方需按约定补偿标准支付空驶费，具体收费标准以乙方平台规则为准（包括但不限于订单页面《异常费用收取与补偿标准》等）。</div>
        <div class="mr_t10">2.1.4 甲方有权获知货物运输情况，确定货物运输是否符合运单要求。</div>

        <h4 class="mr_10">2.2 甲方义务</h4>
        <div class="mr_t10">2.2.1 甲方提供的货物不属于法律规定的违禁品、危险品的服务，甲方应确保货物符合《中华人民共和国道路运输条例》等相关道路运输的法律法规的规定。因甲方货物属于或含有禁止或限制寄递物品而被查没、扣留或变更配送路线，导致乙方损失的（包括但不限于其他承运货物时效延误或价值丧失，给乙方/实际承运人或第三人造成的经济损失），甲方应承担赔偿责任。甲方应配合实际承运人对托运货物进行核查，如实际承运人发现货物属于违禁品或危险货物的，实际承运人有权拒绝装货。</div>
        <div class="mr_t10">2.2.2 甲方应当按照约定的方式或适合运输的方式包装货物。因货物包装问题导致的货物损失，由甲方自行承担。如货物运输至目的地铅锭或封签完好且车辆未发生过交通事故，但车载货物出现丢失、短少、破损的，相应损失与乙方无关。如因甲方货物质量缺陷或包装破损，致使其他物品、运输工具、机械设备被污染腐蚀、损坏，或造成人身伤亡的，甲方应承担全部赔偿责任。</div>
        <div class="mr_t10">2.2.3 货物发车前，甲方应及时安排装车，不得无故拖延时间。货物到达指定目的地后甲方应及时通知收货人；因甲方未及时通知收货人，导致压车等待，甲方应向乙方支付压车等待费，具体收费标准以乙方平台规则为准（包括但不限于订单页面《异常费用收取与补偿标准》等）。甲方有义务实时跟踪委托货物运输情况，甲方一旦在乙方系统中操作确认签收或系统上显示正常签收后，则视为货物已经正常签收。</div>
        <div class="mr_t10">2.2.4 有义务按照合同约定及时向乙方支付应付款项。甲方逾期支付的，每逾期一日，应向乙方支付应付而未付款项的0.3%的违约金，甲方逾期支付超过五日的，乙方有权直接解除本协议，并有权要求甲方赔偿其直接或间接遭受的一切索赔、损失、责任、赔偿、费用（包括但不限于诉讼费、保全费、公证费、律师费、鉴定费、第三方担保服务费等）及开支。</div>
        <div class="mr_t10">2.2.5 甲方有义务保证运单真实、合法、有效。甲方不得与第三方串通以虚假形式发货下单。如在合同期间中，甲方或甲方员工虚假下单或配合第三人虚假下单发货套取乙方资金，导致乙方损失包括但不限于向承运人支付的运费、利润等，由甲方承担赔偿责任，如认定第三人承担赔偿责任的，则甲方承担无限连带责任。甲方对此放弃任何抗辩权，另乙方有权立即单方终止本合同，如涉及犯罪，则乙方移交公安机关处理。甲方保证系统下单时货物并未在运输途中，乙方不同意甲方先行安排车辆运输，即在货物已经开始运输后，再在乙方平台下单。如乙方后期发现以上情况，无论乙方是否已接单或已收取相应的运费，该单货物所对应的运输风险乙方均不承担，如货物在途中发生包括但不限于丢失、破损、受潮、污染等情况造成损失，则由甲方自行与第三方司机沟通解决，与乙方无关。</div>
        <div class="mr_t10">2.2.6 甲方负责货物的装卸工作，即货物出发前由甲方负责将货物装运上车，货物到达目的地后，由甲方指定通知的收货人负责将货物装卸下车。如在货物装卸过程中发生异常导致包括但不限于货物损坏、人身伤害等情况，与乙方无关。如造成乙方损失的，由甲方负责赔偿乙方损失。</div>
        <div class="mr_t10">2.2.7 甲方发布货运信息时应当严格遵守车辆装载的要求，根据托运货物重量、体积选择合适的车型车长，避免超载超限。如甲方托运货物可能导致超载超限的，实际承运人有权拒绝装货。如因货物装载超载、超高、超宽导致发生包括但不限于交通事故、政府罚款、货物破损、丢失等情况，由甲方自行承担责任，如造成乙方或乙方委托的该订单实际承运人损失的，由甲方承担并赔偿。</div>
        <div class="mr_t10">2.2.8 甲方及其收货人应在货物签收前仔细查验货物，如正常签收后发现货物异常要求乙方赔偿的，则乙方不予赔偿。甲方不得以货物理赔拒付已到期运费，如合作期间内，发生货物损失，经双方书面确认后，甲方有权在运费中予以扣除理赔款，但双方约定，对应的理赔款乙方无需开具运输发票，乙方按照运费扣除理赔款后实际应付金额开具等额运输类发票。</div>
        <div class="mr_t10">2.2.9 乙方标志（指乙方或其任何关联方的商标、商号或其他名称（包括但不限于顺丰及其图形、文字等））的权利（含知识产权）归属乙方，未经乙方事先书面同意，甲方不可自行或允许他人对外披露与乙方的合作事宜及任何细节（甲方基于事实，在封闭商业行为中，在不负担与乙方的保密义务下，例如在招投标时真实、合理、适度地宣传除外），甲方也不可在任何生产、销售、宣传、出版中使用乙方的标志。甲方在向乙方沟通前述使用需求时，应当同时提交拟使用的材料供乙方审核。甲方违反前述约定的，乙方有权终止合作，并要求消除影响、赔礼道歉、赔偿乙方因此造成的全部损失及费用支出。</div>

        <h4 class="mr_10">2.3 乙方权利</h4>
        <div class="mr_t10">2.3.1 乙方有权按照合同约定向甲方收取运费及其它增值服务费用，并有义务开具运输类增值税发票。</div>
        <div class="mr_t10">2.3.2 乙方在运输过程因包括但不限于堵车、交通事故、天气变化、车辆限行、司机正常休息等因素影响，可能无法在预计运行时长内到达，如超出运输时效，乙方无需向甲方承担任何赔偿责任。</div>
        <div class="mr_t10">2.3.3 非乙方原因，对于超过运单约定期限仍无法交付的货物，乙方有权对货物提存。甲方如有未按时支付运费、保管费以及其他与运输相关费用等违约行为，乙方对货物享有留置权。留置期限为3个月，货物性质不能留置的除外。期限届满，甲方仍未付清费用的，乙方可以以合理的价格变卖货物并就货款优先受偿。</div>

        <h4 class="mr_10">2.4 乙方义务</h4>
        <div class="mr_t10">2.4.1乙方有义务保证实际承运人按照相关法律、法规的要求，利用恰当的存储方式、运输工具，安全、合法地配送货物。 </div>
        <div class="mr_t10">2.4.2乙方有义务按照运单要求的车型安排车辆，并确保车辆在运输过程中正常运行，对运输过程中出现的任何异常第一时间通知甲方，并采取适当措施减少或消除甲方的损失。</div>
        <div class="mr_t10">2.4.3 甲方下单并支付运费后，如乙方在20分钟内无法安排运输车辆，甲方可无责取消订单，乙方在24小时内向甲方原路退还所有运费。如乙方不取消订单，对于逾期派送车辆导致的货物装运延误乙方无需承担任何违约责任。</div>
        <div class="mr_t10">2.4.4 乙方有义务保证实际承运人将货物安全、如数、无损、及时地运达甲方指定的地点，交于收货人并办理交接手续，要求收货人在签收单上签字或加盖业务用章，签收时间为货物交付收货人的时间。若货物在运输途中出险，乙方应马上向当地公安机关和甲方投保的保险公司报案（如有投保），提供相应证据，配合甲方理赔。若货物有差异的、包裹有破损、玷污、水浸等现象造成收货人拒收的，乙方应及时反馈甲方，并配合甲方反馈的要求进行操作。</div>
        <div class="mr_t10">2.4.5 乙方有义务在出现非乙方原因造成的货品质量、数量损失时，立即以邮件或电话形式通知甲方并根据具体情况协助甲方解决。</div>

        <h4 class="mr_20">3、结算及开票</h4>
        <div class="mr_t10">3.1 本合同项下，甲方向乙方支付的运费的结算具体以“顺丰运力”中甲方账号（包括但不限于出车记录等）显示的数据为准。如数据出现错误或与实际情况不一致的，以双方确认的数据为准。 </div>
        <div class="mr_t10">3.2 结算方式： 预付模式：甲方通过银行转账方式向乙方预付运费，当预付余额不足时，甲方应及时补充预付款，如甲方未能及时补足预付款，乙方有权只提供余额限额内的服务。 </div>
        <div class="mr_t10">3.3 对账开票：月度对账开票，双方于每月5日前完成上月账单核对（节假日顺延），乙方在双方完成账单核对后 5 个工作日内根据甲方确认的账单金额开具增值税专用发票。 </div>
        <div class="mr_t10">3.4 经双方协商，乙方向甲方开具税率为9%的运输业增值税专用发票。按照国家相关税收法律法规的规定，合同各方按照纳税义务分别承担与本合同相关的税费。 </div>
        <div class="mr_t10">3.5 乙方指定的对公账户信息如下： </div>
        <div class="mr_t20">开户名：<span class="date">{{contractMsg.accountName}}</span></div>
        <div>开户行：<span class="date">{{contractMsg.bankOfDeposit}}</span></div>
        <div>账　号：<span class="date">{{contractMsg.accountNumber}}</span></div>

        <h4 class="mr_20">4、关联企业结算 </h4>
        <div class="mr_t10">4.1 出于合作的便利性，甲乙双方确认，本合同及附件的内容同样适用于甲方与乙方关联企业之间发生的业务，乙方关联企业为甲方提供运输服务时应遵照本合同及附件的约定执行,履行本合同的权利义务。乙方关联企业信息详见附件（一）《乙方关联企业清单》。 </div>
        <div class="mr_t10">4.2 乙方关联公司依据本合同为甲方提供公路运输服务的，甲乙双方同意按照独立结算方式进行结算，即由乙方关联公司结算账号按各自与甲方实际发生的交易进行独立的费用结算。 </div>

        <h4 class="mr_20">5、反商业贿赂</h4>
        <div class="mr_t10">5.1双方确认并同意严格遵守中国人民共和国关于反商业贿赂的有关法律法规的规定，在洽谈、协商签署及履行本合同过程中，双方均不得向对方及对方工作人员及其近亲属提供、给予合同约定外的任何利益。 </div>
        <div class="mr_t10">5.2任何一方违反本条款约定的，对方有权解除本合同，由此引起的所有责任由违约方承担。 </div>

        <h4 class="mr_20">6、不可抗力条款</h4>
        <div class="mr_t10">6.1“不可抗力”是指各方不能合理控制、不可预见或即使预见亦无法避免的事件，该事件妨碍、影响或延误任何一方根据协议履行其全部或部分义务。该事件包括但不限于政府行为、法律法规规定、网络攻击、网络事故、自然灾害、战争或任何其它类似事件。 </div>
        <div class="mr_t10">6.2出现不可抗力事件时，发生不可抗力的一方应及时、充分地以书面形式向对方告知不可抗力事件，并告知对方该类不可抗力事件对本合同可能产生的影响，并应当在合理期限内提供相关证明。 </div>
        <div class="mr_t10">6.3因不可抗力致使乙方不能及时提供服务的，乙方应在不可抗力及意外事故发生后15个工作日内通知甲方，并采取相关补救措施。由于以上所述不可抗力事件致使本合同的部分或全部条款不能履行或延迟履行，则各方于彼此间不承担任何违约责任。 </div>

        <h4 class="mr_20">7、运输责任条款</h4>
        <h4 class="mr_10">7.1 运输责任期间：乙方自甲方在乙方系统平台上下单成功且货物装运上车完成后（两者同时满足）开始承担运输责任，在运输过程中承担运输责任，货物到达甲方指定的目的地后运输责任完成。在运输过程中货物装运上车及货物卸载下车期间导致的货物异常情况由甲方自行承担，乙方无需承担。</h4>
        <h4 class="mr_10">7.2 因下列原因造成延误、无法承运、丢失破损的，乙方不承担赔偿责任：</h4>
        <div class="mr_t10">7.2.1 因不可抗拒因素造成的。不可抗拒因素包括但不限于地震、泥石流、洪涝灾害、火灾等自然灾害；台风、暴雨雪、雾霾等恶劣天气；疫情、罢工、恐怖事件、意外交通事故、道路/桥梁坍塌、法规政策的修改、政府、司法机关的行为、决定或命令；抢劫、抢夺等暴力犯罪； </div>
        <div class="mr_t10">7.2.2 因货物的自然性质、内在缺陷或合理损耗造成的；因货物包装不符合运输要求或货物在运输途中自然脱落导致货物损失； </div>
        <div class="mr_t10">7.2.3 因货物原因导致车辆发生自燃，或甲方委托的货物属于国家违禁品、易燃易爆品导致货物损失的； </div>
        <div class="mr_t10">7.2.4 因甲方、收件人的自身过错或第三方原因造成的。如甲方未履行如实申报告知的义务、违规寄递货物的，收件人迟延受领托寄物等情形。 </div>
        <h4 class="mr_10">7.3 基于托寄物可能获得的收益、利润、实际用途、商业机会、商业价值等任何间接损失，乙方不承担赔偿责任。 </h4>

        <h4 class="mr_20">8、理赔约定</h4>
        双方按照公平原则及诚实信用原则就货物损失理赔规则约定如下：
        <h4 class="mr_10">8.1 如甲方未事先向乙方声明货物实际价值并委托乙方向保险公司购买保险的，因可归责于乙方的原因造成甲方损失的，双方确认乙方对双方签订的每笔运单项下货物的毁损、灭失、逾期等损失的最高赔偿的限额为人民币【伍万】元整，乙方对超出该限额的损失不承担任何赔偿责任，乙方在最高【伍万】元限额以内按照甲方实际损失进行赔偿。如甲方委托乙方对整车货物予以投保，乙方应配合甲方向保险公司办理理赔。如本条约定与双方（包括甲乙双方各子公司、分公司之间）签署的其他合同约定的理赔条款不一致或冲突的，以本条约定为准。 </h4>
        <h4 class="mr_10">8.2 甲方保证托运货物不属于如下异常货物，如甲方托运的货物全部或部分为异常货物，且在运输过程中发生异常包括但不限于污染、受潮、毁损、破损、灭失等情况导致货物损失的，则乙方最高在该趟货物运费【三】倍限额内向甲方承担赔偿责任（例如甲方货物价值为1万，运费100元，货物在运输过程中整车灭失，则乙方赔偿责任最高仅限于300元），超出部分货物损失由甲方自行承担。</h4>
        <div class="mr_t20">
          <div>
            <center>
              <h4>异常货物明细</h4>
            </center>
          </div>
          <table class="table1 mr_t10">
            <tr>
              <th>类型</th>
              <th>举例</th>
            </tr>
            <tr>
              <td>危险品</td>
              <td>易燃、易爆、有毒、腐蚀物及挥发性液体物品、烟花爆竹、各种压缩气体</td>
            </tr>
            <tr>
              <td>易碎品</td>
              <td>酒水类、易碎品</td>
            </tr>
            <tr>
              <td>对运输有特殊要求的货物</td>
              <td>防震动、防倾斜、防尘、对温度湿度有要求、精密仪器</td>
            </tr>
            <tr>
              <td>二手货物或旧货物</td>
              <td>旧设备、二手家具等</td>
            </tr>
            <tr>
              <td>难以确定保险价值的货物</td>
              <td>工艺品（包括各类雕刻、编织、刺绣、古董、字画、瓷器、玉石、盆景、摆件等等）、现金、有价证券、珠宝首饰、贵金属以及计算机软件等</td>
            </tr>
            <tr>
              <td>易变质货物</td>
              <td>海鲜、新鲜水果、新鲜蔬菜、鲜花、鲜活动植物、蛋制品、血液制品、疫苗</td>
            </tr>
            <tr>
              <td>散装货</td>
              <td>各类散装农产品（果仁、花生、大豆等谷物、粮食作物、菜籽饼、地瓜干、木薯干等）；散装化工类货物，如煤炭、矿石/砂、镍矿、石油及柴油、沥青、焦油等各类石油提炼品、饲料、化肥、水泥等</td>
            </tr>
            <tr>
              <td>受损后无法在国内进行检测、定损、维修</td>
              <td>一些进口的专业设备仪器等等</td>
            </tr>
            <tr>
              <td>超大件设备</td>
              <td>长度在14米以上或宽度在3.5米上或高度在3米以上的货物，或者重量在20吨以上的单体货物或不可解体的成组（捆）货物</td>
            </tr>
            <tr>
              <td>特殊货物</td>
              <td>风力发电机所使用的主机及叶片、太阳能面板及太阳能产品的生产设备、各类银行终端设备、汽车、摩托车、电动自行车</td>
            </tr>
          </table>
        </div>
        <h4 class="mr_10">8.3 货物发生损失后，甲方应及时向乙方提交理赔资料。如甲方未及时提交或提交的资料不符合乙方保险公司要求，乙方有权要求甲方重新补充提交完整的资料，如甲方无法补充提交导致乙方保险公司不予定损，则乙方对该部分损失不予赔偿。最终货物损失金额以保险公司定损或人民法院判决书为准。具体材料要求包括： </h4>
        <div class="mr_t10">8.3.1 车载货物明细：装箱单/发货单/运载货物清单或重量单、上游运单原件；</div>
        <div class="mr_t10">8.3.2 货损证明材料：货物损失清单（被损坏货物的名称、单价、数量、总价）；销售发票/销售合同、理赔协议、赔付银行回单；维修方案及报价单，或修复/重置受损货物的发票/收据（如果货物需要维修需要提供些证明）；第三方检验报告或其它可以表明灭失或损毁程度的书面证据（如果货物需要维修，则需公估机构提供一个货物维修的价格证明即可）；</div>
        <div class="mr_t10">8.3.3 货损原因证明材料：收货人签发的注明货损或者短量情况的提供单/货运单或货物交接单（若卸货时发生货损，则需提供货损被拒收的详细清单）。</div>

        <h4 class="mr_20">9、其它条款</h4>
        <div class="mr_t10">9.1甲方管理账号在“顺丰运力”以填写、勾选、点击等任何方式确认的内容,都是本合同的重要组成部分，与本合同具有同等效力。</div>
        <div class="mr_t10">9.2乙方有权对“顺丰运力”进行维护和升级，因“顺丰运力”维护和升级导致托运人管理账号出现异常的，甲方应及时通知乙方，乙方在接到通知后应及时对甲方管理账号异常问题进行处理。甲方同意并知悉，因“顺丰运力”维护和升级导致甲方管理账号无法登录和操作的，乙方不承担任何责任。</div>
        <div class="mr_t10">9.3鉴于乙方因承担甲方运输业务，已经、将要或可能知悉、掌握甲方或甲方客户的货物、业务量、线路、班次、站点、时间、运作流程、价格等相关经营信息（含货物运单信息、甲方客户信息）及甲方未予公开的其他商业秘密，乙方均负有保密义务，不得予以公开或向任何第三方提供。</div>
        <div class="mr_t10">9.4如甲乙双方就本合同发生争议,应以友好原则协商解决。如不能协商一致,应向本合同签订地：深圳市南山区人民法院提起诉讼。</div>

        <h4 class="mr_20">10、通知与送达</h4>
        <div class="mr_t10">10.1与本合同有关的全部通知，可以采取书面邮寄形式或者电子邮件等形式发出。任何一方按照本合同列明的电子邮箱，向对方发出与本合同有关的通知、对账单等，发件人电子邮件系统确认发送成功则视为该通知已经送达对方；凡是按照本合同列明的各方通信地址（确保该通讯邮箱&电话可用），向其发出的与本合同有关的通知、文件、文书（包括诉讼文书）等，于投邮后第3个工作日的上午九时均视为已经送达。</div>
        <div class="mr_t10">10.2通知到达对方时，即按照本合同相关约定发生相应法律效力。</div>
        <div class="mr_t10">10.3甲方下单人（发货员）包括但不限于下表载明的业务代表及期间新增、变更的人员，如变更或增加下单人，甲方需邮件、书面告知乙方甲方变更人员的手机号、姓名。另在合同期间内，如就非本合同载明的下单人成单的订单，甲方进行了交货，或进行对账或抵扣相应发票或结算等操作即表示甲方对该下单人的代理行为予以追认，甲方对该下单人的系统操作行为负责。双方联系方式如下：</div>
        <div>
          <table class="table1 width_80 mr_t10">
            <tr>
              <th>项目</th>
              <th style="width:35%">甲方</th>
              <th style="width:35%">乙方</th>
            </tr>
            <tr>
              <td>联系人姓名及身份证号</td>
              <td>{{contractMsg.contactName}}/{{contractMsg.contractIdNumber}}</td>
              <td>{{contractMsg.partyNameB}}/{{contractMsg.partyNumber}}</td>
            </tr>
            <tr>
              <td>联系人地址</td>
              <td>{{contractMsg.contactAddress}}</td>
              <td>{{contractMsg.partyAddress}}</td>
            </tr>
            <tr>
              <td>联系人邮箱</td>
              <td>{{contractMsg.contactMail}}</td>
              <td>{{contractMsg.partyMail}}</td>
            </tr>
            <tr>
              <td>联系人电话</td>
              <td>{{contractMsg.contactPhone}}</td>
              <td>{{contractMsg.partyPhone}}</td>
            </tr>
          </table>
        </div>
        <div class="mr_t10">以上联系方式也作为有效司法送达地址。</div>
        <div class="mr_t10">10.4各方自行承担因上述联系方式丢失、泄露或允许他人使用所产生的后果。</div>
        <div class="mr_t10">10.5双方代表己方处理与己方相关货运事宜，该代表在合同履行过程中的签字／邮件/留言行为视为被代表方的行为。任何一方上述联系人、联系方式发生变化的，应至少提前10日书面告知另一方，否则视为未变更，另一方向本合同载明的联系人、联系方式发送的任何通知、对账单等仍然视为符合本合同要求。</div>

        <h4 class="mr_20">11、合同生效、变更与终止</h4>
        <div class="mr_t10">11.1 本合同自双方盖章之日起生效，有效期自<span class="date">{{contractMsg.startYear }}</span>年<span class="date">{{contractMsg.startMonnth}}</span>月<span class="date">{{contractMsg.startDay}}</span>日至<span class="date">{{contractMsg.endYear}}</span>年<span class="date">{{contractMsg.endMonnth}}</span>月<span class="date">{{contractMsg.endDay}}</span>日止。具体合作线路时间以甲方在乙方平台下达完成的订单信息为准。本合同一式 叁 份，甲方执 壹 份，乙方执 贰 份，具有同等法律效力。</div>
        <div class="mr_t10">11.2 甲乙双方必需认真履行合同中的各项规定，若其中任何一方因故需变更合同中的任何条款时，都必须经双方协商签署变更协议后，方可执行。</div>
        <div class="mr_t10">11.3在本合同约定的合作期限内，如因法律法规或相关政策的更新或变更等因素导致乙方不具有网络货物运输相关资质的，本合同自动终止。</div>
        <div class="mr_t10">11.4一方严重违约，另一方可根据本合同约定终止本合同。</div>
        <div class="mr_t10">11.5除本协议另有约定外，双方均有权在提前1个月书面通知对方的前提下终止本协议，但本合同的终止并不解除合同双方对各自在合同终止前的行为所负的责任和义务。</div>

        <h4 class="mr_20">12、附件</h4>
        <div class="mr_t10">附件1：《乙方关联企业清单》</div>
        <div class="mr_t10">附件2：《授权委托书模板》</div>
        <div class="mr_t10">附件3：《异常费用收取与补偿标准》</div>
        <div class="mr_t10">（以下无正文）</div>
        <br />
        <div>
          <table class="width_100">
            <tr>
              <td class="width_50">甲方：<span class="date">{{contractMsg.customerName}}</span></td>
              <td>乙方：<span class="date">{{contractMsg.partyName}}</span></td>
            </tr>
            <tr>
              <td style="padding-left:60px">（盖章）</td>
              <td style="padding-left:60px">（盖章）</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>法定代表/授权代表（签字）： <span class="date">{{contractMsg.corporaName}}</span></td>
              <td>法定代表/授权代表（签字）： <span class="date">{{contractMsg.partyNameLegal}}</span></td>
            </tr>
            <tr>
              <td>日期：<span class="date">{{this.year}}</span>年<span class="date">{{this.month}}</span>月<span class="date">{{this.day}}</span>日 </td>
              <td>日期：<span class="date">{{this.year}}</span>年<span class="date">{{this.month}}</span>月<span class="date">{{this.day}}</span>日 </td>
            </tr>
          </table>
        </div>

        <div class="mr_t100">
          <div>
            <center><b>附件1 乙方关联企业清单</b></center>
          </div>
          <table class="table1 mr_t10 width_100">
            <tr>
              <td class="t_c">江西顺丰智达网络科技有限公司</td>
            </tr>
            <tr>
              <td class="t_c">浙江丰驰网络科技有限公司</td>
            </tr>
          </table>
        </div>

        <div class="mr_t100">
          <div>
            <center><b>附件2 授权委托书模板</b></center>
          </div>
          <div class="mr_t20">
            <center><b>授权委托书</b></center>
          </div>
          <div class="mr_t10">致<u>&nbsp;　　　　　　&nbsp;</u>及其关联公司（下称贵司）： </div>
          <div class="mr_t10">　　我司兹授权以下人员在贵司顺丰运力平台开通货主账户作为我司在贵司平台进行报价、提货、运费对账结算（付款、发票申请等）、签署合同等操作的特别授权人。 </div>
          <div class="mr_t10">　　特别授权人在贵司平台以上操作行为均视为我司行为，所有责任由我司承担。我司将按照合同约定向贵司承担相应的责任。 </div>
          <table class="table1 mr_t10 width_80">
            <tr>
              <td>序号</td>
              <td>姓名</td>
              <td>身份证号</td>
              <td>手机号</td>
            </tr>
            <tr>
              <td>1</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <div class="mr_t10">　　如以上授权人员有变更，我司将提前10天书面通知贵司，如未收到书面通知，以上记载的在贵司平台的操作行为均视为我司行为，请知悉！ </div>
          <div class="mr_t10" style="padding-left:50%;padding-top:30px;">授权单位（盖章）：</div>
          <div class="mr_t10" style="padding-left:50%">日期：　　　年　　　月　　　日</div>
        </div>

        <div class="mr_t100">
          <div>
            <center><b>附件3 异常费用收取与补偿标准</b></center>
          </div>
          <h4 class="mr_10">一、放空/取消收取与补偿标准</h4>
          <table class="table1 mr_t10 width_100">
            <tr>
              <td>放空/取消责任</td>
              <td>放空/取消场景</td>
              <td colspan="3">收取与补偿标准</td>
            </tr>
            <tr>
              <td>司机原因放空/取消</td>
              <td>-</td>
              <td colspan="3">平台补偿货主200元，或选择货主加价平台继续找车</td>
            </tr>
            <tr>
              <td rowspan="8">货主有责放空/取消</td>
              <td>已派车货主未支付</td>
              <td colspan="3">扣除货主200积分，如积分不足需支付20元违约金</td>
            </tr>
            <tr>
              <td>已派车货主已支付</td>
              <td colspan="3">50元起缴</td>
            </tr>
            <tr>
              <td>费用类型</td>
              <td>车型</td>
              <td>里程</td>
              <td>收取标准</td>
            </tr>
            <tr>
              <td rowspan="3">司机空驶费</td>
              <td>4.2米及6.5米</td>
              <td>司机实际行驶距离*2元/公里</td>
              <td>最低50元起，上限150元</td>
            </tr>
            <tr>
              <td>7.6米及9.6米</td>
              <td>司机实际行驶距离*2.5元/公里</td>
              <td>最低50元起，上限200元</td>
            </tr>
            <tr>
              <td>13.5米及16.5米</td>
              <td>司机实际行驶距离*3元/公里</td>
              <td>最低50元起，上限300元</td>
            </tr>
            <tr>
              <td>司机等待费</td>
              <td colspan="3">按照司机实际靠台后等待时间追加额外补偿10元/时</td>
            </tr>
            <tr>
              <td colspan="4">货主有责取消需50元起缴，如司机有空驶及等待费用根据实际情况合并计算</td>
            </tr>
          </table>
          <h4 class="mr_10">二、货主运单压车收取标准</h4>
          <table class="table1 mr_t10 width_100">
            <tr>
              <td rowspan="2">车型</td>
              <td rowspan="2">时间端</td>
              <td colspan="3">压车费收取标准</td>
            </tr>
            <tr>
              <td>12-36小时</td>
              <td>36-60小时</td>
              <td>60小时以上</td>
            </tr>
            <tr>
              <td rowspan="3">4.2米</td>
              <td>8：00-20：00</td>
              <td>3元/时</td>
              <td>5元/时</td>
              <td>10元/时</td>
            </tr>
            <tr>
              <td>20：00-次日8：00</td>
              <td>5元/时</td>
              <td>5元/时</td>
              <td>5元/时</td>
            </tr>
            <tr>
              <td>上限</td>
              <td>100元/天</td>
              <td>120元/天</td>
              <td>180元/天</td>
            </tr>
            <tr>
              <td rowspan="3">6.5米</td>
              <td>8：00-20：00</td>
              <td>5元/时</td>
              <td>10元/时</td>
              <td>15元/时</td>
            </tr>
            <tr>
              <td>20：00-次日8：00</td>
              <td>5元/时</td>
              <td>5元/时</td>
              <td>5元/时</td>
            </tr>
            <tr>
              <td>上限</td>
              <td>120元/天</td>
              <td>180元/天</td>
              <td>240元/天</td>
            </tr>
            <tr>
              <td rowspan="3">7.6米</td>
              <td>8：00-20：00</td>
              <td>10元/时</td>
              <td>15元/时</td>
              <td>20元/时</td>
            </tr>
            <tr>
              <td>20：00-次日8：00</td>
              <td>5元/时</td>
              <td>5元/时</td>
              <td>5元/时</td>
            </tr>
            <tr>
              <td>上限</td>
              <td>180元/天</td>
              <td>240元/天</td>
              <td>300元/天</td>
            </tr>
            <tr>
              <td rowspan="3">9.6米</td>
              <td>8：00-20：00</td>
              <td>15元/时</td>
              <td>20元/时</td>
              <td>25元/时</td>
            </tr>
            <tr>
              <td>20：00-次日8：00</td>
              <td>5元/时</td>
              <td>5元/时</td>
              <td>5元/时</td>
            </tr>
            <tr>
              <td>上限</td>
              <td>240元/天</td>
              <td>300元/天</td>
              <td>360元/天</td>
            </tr>
            <tr>
              <td rowspan="3">13.5米</td>
              <td>8：00-20：00</td>
              <td>15元/时</td>
              <td>20元/时</td>
              <td>25元/时</td>
            </tr>
            <tr>
              <td>20：00-次日8：00</td>
              <td>10元/时</td>
              <td>10元/时</td>
              <td>10元/时</td>
            </tr>
            <tr>
              <td>上限</td>
              <td>300元/天</td>
              <td>360元/天</td>
              <td>420元/天</td>
            </tr>
            <tr>
              <td rowspan="3">16.5米</td>
              <td>8：00-20：00</td>
              <td>25元/时</td>
              <td>30元/时</td>
              <td>35元/时</td>
            </tr>
            <tr>
              <td>20：00-次日8：00</td>
              <td>10元/时</td>
              <td>10元/时</td>
              <td>10元/时</td>
            </tr>
            <tr>
              <td>上限</td>
              <td>420元/天</td>
              <td>480元/天</td>
              <td>540元/天</td>
            </tr>
            <tr>
              <td colspan="5">1、按小时计费，超过12小时开始计时，12-36小时为1天，36-60小时为2天，以及60小时以上；</td>
            </tr>
            <tr>
              <td colspan="5">2、司机提前到达，按货主计划靠台时间计算压车时长；</td>
            </tr>
            <tr>
              <td colspan="5">3、司机晚于靠台时间到达，按司机实际到达时间计算压车时长。</td>
            </tr>
          </table>
          <h4 class="mr_10">三、货主运单修改地址、增加/减少经停点收取标准</h4>
          <table class="table1 mr_t10 width_100">
            <tr>
              <td style="width:30%">修改类型<br />点位费</td>
              <td style="width:30%">点位费</td>
              <td style="width:30%">修改后运费计算方式</td>
            </tr>
            <tr>
              <td>修改地址-里程增加</td>
              <td>-</td>
              <td rowspan="4">按修改后实际里程及单公里运费，与增减经停点进行运费核算</td>
            </tr>
            <tr>
              <td>修改地址-里程减少</td>
              <td>-</td>
            </tr>
            <tr>
              <td>增加经停点</td>
              <td>200元/个</td>
            </tr>
            <tr>
              <td>减少经停点</td>
              <td>200元/个</td>
            </tr>
            <tr>
              <td colspan="3">同城修改地址可在顺陆APP进行修改 ，跨城修改需致电400-111-6663客服修改</td>
            </tr>
          </table>
          <h4 class="mr_10">四、货主运单运输时效晚点补偿标准</h4>
          <table class="table1 mr_t10 width_100">
            <tr>
              <td>晚点时长<br />长途补偿标准</td>
              <td>长途补偿标准</td>
              <td>短途补偿标准</td>
            </tr>
            <tr>
              <td>0分钟≤晚点时长&lt;60分钟</td>
              <td>200元/单</td>
              <td>100元/单</td>
            </tr>
            <tr>
              <td>60分钟≤晚点时长&lt;120分钟</td>
              <td>300元/单</td>
              <td>200元/单</td>
            </tr>
            <tr>
              <td>120分钟≤晚点时长&lt;240分钟</td>
              <td>400元/单</td>
              <td>300元/单</td>
            </tr>
            <tr>
              <td>240分钟≤晚点时长&lt;360分钟</td>
              <td>500元/单</td>
              <td>500元/单</td>
            </tr>
            <tr>
              <td>晚点时长≥360分钟</td>
              <td>800元/单</td>
              <td>800元/单</td>
            </tr>
            <tr>
              <td colspan="3">长途指系统中路线长度大于等于300公里，短途指系统中路线长度小于300公里</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="btn">
        <el-button v-if="!openType" type="primary" @click="agree">同 意</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import fetchPost from "@/api/http.js";
export default {
  props: {
    contractRow: {
      type: Object,
      default() {
        return {}
      }
    },
    openType: {//按钮类型
      default() {
        return ""
      }
    },
    pageType: {//页面类型 1.合同列表 2.发临时单
      default() {
        return ""
      }
    }
  },
  data() {
    return {
      contractDialogVisible: false,
      contractMsg: {},
      year: "",
      month: "",
      day: ""
    }
  },
  methods: {
    getDate(val) {
      var date = "";
      if (val) {
        date = new Date(val);
      } else {
        date = new Date();
      }
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1;
      if (this.month < 10) this.month = "0" + this.month;
      this.day = date.getDate();
      if (this.day < 10) this.day = "0" + this.day;
    },
    agree() {
      var data = {
        id: this.contractRow.id
      };
      fetchPost("/saas/contract/agreeToSignContract", data).then(res => {
        //console.log(res)
        if (res == '签署成功') {
          this.$message({
            type: 'success',
            message: '合同签署成功'
          })
          if(this.pageType == 1){
            this.$emit("querySaasContractList");
          } else {
            this.$emit("signedSuccessfully");
          }          
        }
      });
      this.contractDialogVisible = false;
    },
    queryContractInfo(query) {
      this.contractDialogVisible = true;
      var data = {
        id: query
      };
      fetchPost("/saas/contract/queryContractInfo", data).then(res => {
        this.contractMsg = res;
        if (this.openType == 1) {
          this.getDate(this.contractRow.siginingDate);
        } else {
          this.getDate();
        }

      });

    }
  }
}
</script>
<style scoped>
.contract_box {
  height: 500px;
  width: 100%;
  padding: 0 10px !important;
}
.btn {
  text-align: center;
  padding: 24px 0 !important;
}
.contractName {
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-weight: bold;
}
.t_r {
  text-align: right;
}
.t_c {
  text-align: center;
}
.mr_20 {
  margin: 20px 0 !important;
}
.mr_10 {
  margin: 10px 0 !important;
}
.mr_t10 {
  margin-top: 11px !important;
}
.mr_t20 {
  margin-top: 20px !important;
}
.mr_t100 {
  margin-top: 100px !important;
}

.ti {
  text-indent: 28px;
}
.table1 {
  border-collapse: collapse;
}
.table1 th,
.table1 td {
  border: 1px solid black;
}
table td {
  padding: 5px;
}
.width_100 {
  width: 100%;
}
.width_90 {
  width: 90%;
}
.width_80 {
  width: 80%;
}
.width_60 {
  width: 60%;
}
.date {
  text-decoration: underline;
  padding: 0 5px !important;
}
</style>